export default {"src":"/_next/static/media/TURBO_Logo_RGB.d8164855.svg","height":126,"width":175};